import Layout from  './Layout'

export default Layout

export Header from './Header'
export Footer from './Footer'
export Main from './Main'
export Nav from './Nav'
export Menu from './Menu'
